module.exports = __webpack_public_path__ + "img/pixartprinting-instagram-4.a6add32.png";